import { create } from "zustand";
import { DashboardInfo } from "@/types/referals";

interface DashboardState {
  dashboardInfo: DashboardInfo | null;
  setDashboardInfo: (elem: DashboardInfo | null) => void;
}

export const useDashboardStore = create<DashboardState>()((set) => ({
  dashboardInfo: null,
  setDashboardInfo: (elem) =>
    set(() => ({
      dashboardInfo: elem,
    })),
}));
